import { BaseClass } from './base';

export class MonitoringAlarmProperties {
  constructor(props) {
    this.expression = {
      comparisonOperator: '',
      comparisonThreshold: '',
      metric: '',
      range: '',
      rangeAggregation: '',
      source: {
        uuid: '',
      },
      unit: '',
    };

    this.firingActions = [];
    this.transitions = [];
    this.location = '';
    this.name = '';
    this.alarmDelay = '';
    this.state = '';
    this.stateTransitionedDate = '';

    if (props) {
      Object.assign(this, props);
    }
  }
}

export class MonitoringAlarm extends BaseClass {
  constructor(props) {
    super(props);

    this.properties = new MonitoringAlarmProperties();
    this.entities = {
      firingActions: {},
      transitions: {},
    };

    this.type = 'alarm';

    if (props) {
      Object.assign(this, props);
    }
  }
}
